import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = null;

export const holdingList = createSlice({
    name: "holdingList",
    initialState: {
        value: initialStateValue,
    },
    reducers: {
        setHoldingListReducer: (state, action) => {
            state.value = action.payload;
        },
        clearHoldingListReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});
export const { setHoldingListReducer, clearHoldingListReducer } = holdingList.actions;
export default holdingList.reducer;
